import { Injectable } from '@angular/core';
import { Observable, pipe } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { Funnel } from '../models/funnel';
import { RequestService } from '../../lib/services/requestService';

@Injectable()
export class FunnelService {
  private _apiEndpoint = environment.apiUrl + 'analytics/job/';

  constructor(private http: HttpClient) {}

  getFunnel(jobId: number): Observable<Funnel> {
    return this.http
      .get(`${this._apiEndpoint}${jobId}/application-funnel/`)
      .pipe(map((res: any) => res));
  }
}
